import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Confirm from '../../components/elements/Confirm'
import PrintBatteriesPopup from '../popups/batteries/PrintBatteriesPopup'

import PrintFullInventoryAction from '../../actions/print/PrintFullInventoryAction'
import PrintPipesAction from '../../actions/print/PrintPipesAction'

class SpecialPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      // Is asking to print full inventory
      isPrintingFullInventory: false,
      // Is asking to print pipes report
      isPrintingPipes: false,
      // Is asking to print batteries
      isPrintingBatteries: false
    }

    // Bind events
    this.onClickPrintFullInventory = this.onClickPrintFullInventory.bind(this)
    this.onConfirmPrintFullInventory = this.onConfirmPrintFullInventory.bind(this)
    this.onClickPrintPipes = this.onClickPrintPipes.bind(this)
    this.onConfirmPrintPipes = this.onConfirmPrintPipes.bind(this)
    this.onClickPrintBatteries = this.onClickPrintBatteries.bind(this)
    this.onClosePrintBatteries = this.onClosePrintBatteries.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // After full inventory printing has been done, close confirm
    if (
      prevProps.fullInventoryIsFetching
      &&
      !this.props.fullInventoryIsFetching
    ) {
      this.setState({
        isPrintingFullInventory: false
      })
      AppUtils.setStatus(
        this.props.fullinventoryError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.fullinventoryError
          ? AppUtils.errorToText(this.props.fullinventoryError)
          : 'Inventaire général imprimé.'
      )
    }
    // After pipes printing has been done, close confirm
    if (
      prevProps.pipesIsFetching
      &&
      !this.props.pipesIsFetching
    ) {
      this.setState({
        isPrintingPipes: false
      })
      AppUtils.setStatus(
        this.props.pipesError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.pipesError
          ? AppUtils.errorToText(this.props.pipesError)
          : 'Liste des tuyaux imprimée.'
      )
    }
  }

  onClickPrintFullInventory() {
    this.setState({
      isPrintingFullInventory: true
    })
  }

  onConfirmPrintFullInventory(proceed) {
    if (proceed) {
      this.props.printFullInventory()
    }
    else {
      this.setState({
        isPrintingFullInventory: false
      })
    }
  }

  onClickPrintPipes() {
    this.setState({
      isPrintingPipes: true
    })
  }

  onConfirmPrintPipes(proceed) {
    if (proceed) {
      this.props.printPipes()
    }
    else {
      this.setState({
        isPrintingPipes: false
      })
    }
  }

  onClickPrintBatteries() {
    this.setState({
      isPrintingBatteries: true
    })
  }

  onClosePrintBatteries() {
    this.setState({
      isPrintingBatteries: false
    })
  }

  render() {
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.COL}>
          <Page.Element
            flex='1 0 0px'
            withBorders={true}
          >
            <Header
              title="Inventaire de tout le matériel du SIS"
            />
            <p>
              {`Permet d'imprimer un inventaire complet de tout le matériel du SIS, sans indications d'emplacements.`}
            </p>
            <Button
              icon='print'
              content='Imprimer maintenant'
              floated='right'
              onClick={this.onClickPrintFullInventory}
            />
          </Page.Element>
          <Page.Element
            flex='1 0 0px'
            withBorders={true}
          >
            <Header
              title="Rapport d'inspection des tuyaux"
            />
            <p>
              {`Permet d'imprimer un rapport des longueurs de tuyaux à des fins d'inspection.`}
            </p>
            <Button
              icon='print'
              content='Imprimer maintenant'
              floated='right'
              onClick={this.onClickPrintPipes}
            />
          </Page.Element>
          <Page.Element
            flex='1 0 0px'
            withBorders={true}
          >
            <Header
              title="Liste des batteries"
            />
            <p>
              {`Permet d'obtenir une liste de batteries pour leur remplacement régulier.`}
            </p>
            <Button
              icon='print'
              content='Imprimer maintenant'
              floated='right'
              onClick={this.onClickPrintBatteries}
            />
          </Page.Element>
        </Page>
        {
          this.state.isPrintingFullInventory
            ? <Confirm
                header="Impression de l'inventaire"
                body="Vous êtes sur le point d'imprimer l'inventaire général du SIS. Celui-ci sera téléchargé au format PDF. Voulez-vous continuer ?"
                confirmText="Imprimer"
                confirmColor='blue'
                confirmIcon='print'
                isProceeding={this.props.fullInventoryIsFetching}
                callback={this.onConfirmPrintFullInventory}
              />
            : null
        }
        {
          this.state.isPrintingPipes
            ? <Confirm
                header="Impression du rapport"
                body="Vous êtes sur le point d'imprimer le rapport d'inspection des tuyaux. Celui-ci sera téléchargé au format PDF. Voulez-vous continuer ?"
                confirmText="Imprimer"
                confirmColor='blue'
                confirmIcon='print'
                isProceeding={this.props.pipesIsFetching}
                callback={this.onConfirmPrintPipes}
              />
            : null
        }
        {
          this.state.isPrintingBatteries
            ? <PrintBatteriesPopup
                onClose={this.onClosePrintBatteries}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

SpecialPage.propTypes = {
  // Properties

  // Redux State
  fullInventoryIsFetching: PropTypes.bool.isRequired,
  fullinventoryError: PropTypes.object,
  pipesIsFetching: PropTypes.bool.isRequired,
  pipesError: PropTypes.object,

  // Redux Actions
  printFullInventory: PropTypes.func.isRequired,
  printPipes: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    fullInventoryIsFetching: state.print.full_inventory.isFetching,
    fullInventoryError: state.print.full_inventory.error,
    pipesIsFetching: state.print.pipes.isFetching,
    pipesError: state.print.pipes.error
  }),
  (dispatch) => ({
    printFullInventory: () => (dispatch(PrintFullInventoryAction({}))),
    printPipes: () => (dispatch(PrintPipesAction({})))
  })
)(SpecialPage)



// WEBPACK FOOTER //
// ./src/containers/pages/SpecialPage.js